if (typeof QuickShop === 'undefined') {
  class QuickShop extends HTMLElement {
    constructor() {
      super()

      this.isCartPage = document.body.classList.contains('template-cart')
      this.badge = this.querySelector('.js-quick-badge')

      this.closeIcon = this.querySelector('.js-close-quick')
      this.closeIcon.addEventListener('click', (e) => {
        this.closeQuick()
      })

      this.addEventListener('click', (e) => {
        const target = e.target
        if (target === this || !target.closest('.js-quick-shop')) {
          this.closeQuick()
        }
      })
    }

    /**
     * JSON'd liquid variant https://shopify.dev/docs/api/liquid/objects/variant
     * @typedef Variant
     * @type {object}
     * @property {Number} id
     * @property {string} sku
     * @property {Boolean} available - is variant available for sale
     * @property {string} option1 - Color
     * @property {string} option2 - Size
     * @property {?string} option3 - FilterColor
     * @property {{src: string}} featured_image
     */

    /**
     * JSON'd liquid product https://shopify.dev/docs/api/liquid/objects/product
     * @typedef Product
     * @type {object}
     * @property {Number} id - an ID.
     * @property {string} title
     * @property {string} handle - permalink
     * @property {string} description
     * @property {Variant[]} variants - list of variants
     * @property {['Color', 'Size', 'Filter Color']} options - filter options
     * @property {string} featured_image
     * @property {string[]} tags
     */

    // Most/All of the data- attributes passed in via product-card
    initialize() {
      if (!document.body.classList.contains('overflow-hidden')) {
        document.body.classList.add('overflow-hidden')
      }

      this.isCartPage = document.body.classList.contains('template-cart')

      /** @type {Product} */
      this.productData = JSON.parse(this.getAttribute('data-product'))

      this.buttonLabels = JSON.parse(
        JSON.parse(this.getAttribute('data-labels'))
      )

      this.backInStock = this.getAttribute('data-back-in-stock').toLowerCase() === 'true'

      this.initInventories()

      this.initActiveVariant()
      this.atc = this.querySelector('.js-quick-atc')

      this.updateBadge()
      this.updateContent('vendor', 'js-quick-vendor')
      this.updateContent('title', 'js-quick-title')
      this.updatePrice()
      this.updateSwatches()
      this.updateSizes()

      this.atc.addEventListener('click', (e) => {
        e.preventDefault()
        const available = this.isAvailable()
        if (available) {
          this.addToCart()
        } else {
          this.closeQuick()
          this.openBackInStockModal()
        }
      })

      this.classList.remove('hidden')

      // Wishlist
      this.renderWishlistIcon()

      this.updateButtons()
    }

    initInventories() {
      this.inventories = this.getAttribute('data-inventories')
      this.variantsSelect = this.querySelector('.js-variants-select')
      this.variantsSelect.innerHTML = this.inventories

      let qty = 0,
        id = 0,
        inventoryQuantity = 0
      this.variantsSelect.querySelectorAll('option').forEach((item) => {
        qty = 0
        id = item.dataset.id
        inventoryQuantity = Number(item.dataset.inventoryQuantityOriginal)
        if (window.__CART__.items.length) {
          window.__CART__.items.map((item) => {
            if (item.id === Number(id)) {
              qty += item.quantity
            }
          })
        }
        item.setAttribute('data-inventory-quantity', inventoryQuantity - qty)
      })
    }

    /**
     * Various variants have quotes in them that are messing comparisons up. I imagine
     * there will be more special characters to throw in here
     */
    fixName(str) { return str.replace('"', "") }

    /**
     * Sets active variant based on the selected swatch from the product-card on quick-shop open
     * or to any available variant if none can be found
     */
    initActiveVariant() {
      const initSwatch = this.dataset.swatch

      if (initSwatch) {
        let optionIndex = -1
        let optName = 'color'
        /** @type {Variant[]} */
        let variants = deepClone(this.productData.variants)

        optionIndex = this.productData.options.indexOf(this.hasOption(optName)) + 1
        variants = variants.filter(
          (variant) => {
            this.fixName(variant[`option${optionIndex}`]) === initSwatch && variant.available
          }
        )

        if (variants.length > 0) {
          this.activeVariant = variants[0]
        } else {
          this.activeVariant = this.productData.variants.filter(
            (variant) => this.fixName(variant[`option${optionIndex}`]) === initSwatch
          )[0]
        }
      } else {
        this.activeVariant =
          this.productData.variants.filter((variant) => variant.available)[0] ||
          this.productData.variants[0]
      }
    }

    openBackInStockModal() {
      const backInStockTitle = document.querySelector(
        '#backinstock-product-title'
      )
      const backInStockImage = document.querySelector('#backinstock-image')
      const backInStockSku = document.querySelector('#backinstockForm--SKU')
      if (backInStockTitle) {
        backInStockTitle.innerHTML = this.productData.title
      }

      if (backInStockImage) {
        if (this.activeVariant.featured_image) {
          const imageUrl = this.activeVariant.featured_image.src.replace(
            '.jpg?',
            '_446x.jpg?'
          )
          backInStockImage.innerHTML = `<img
            src="${imageUrl}"
            alt="${this.productData.title}"
            loading="lazy"
            class="max-w-xl w-[80%] h-[80%] object-top object-cover rounded-[12px] mx-auto md:my-40"
          />`
        }
      }
      if (backInStockSku) {
        backInStockSku.value = this.activeVariant.sku
      }

      toggleBackInStockModal(false)
    }

    renderWishlistIcon() {
      this.querySelector('.js-quick-wishlist').innerHTML = ''
      const node = document.createElement('div')
      node.className = 'item'
      node.dataset.product = this.productData.id
      this.querySelector('.js-quick-wishlist').appendChild(node)
    }

    closeQuick() {
      this.classList.add('hidden')

      document.body.classList.remove('overflow-hidden')
    }

    getSectionsToRender() {
      const cartId = this.isCartPage ? 'cart' : 'js-mini-cart'

      return [
        {
          id: cartId,
          section: document.getElementById(cartId).dataset.id,
          selector: '.js-contents',
        },
      ]
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML
    }

    addToCart() {
      this.atc.disabled = true

      const body = JSON.stringify({
        id: this.activeVariant.id,
        quantity: 1,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      })

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state)

          const cartItems = window.__CART__.items
          let alreadyInCart = false
          if (cartItems.length) {
            window.__CART__.items.map((item) => {
              if (item.id === parsedState.id) {
                item.quantity = parsedState.quantity
                alreadyInCart = true
              }
            })
          }
          if (!alreadyInCart) {
            window.__CART__.items.push(parsedState)
          }

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id)
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            )
          })

          this.closeQuick()
          this.showMiniCart()
        })
        .catch((e) => {
          console.error(e)
        })
    }

    showMiniCart() {
      window.dispatchEvent(new CustomEvent('wantable cart updated'))
      if (!this.isCartPage) {
        window.dispatchEvent(new CustomEvent('ToggleMiniCart'))
      } else {
        window.scrollTo(0, 0)
      }
    }

    updateBadge() {
      this.badge.innerHTML = ''

      if (this.productData.tags) {
        const badgeTags = this.productData.tags.filter((tag) =>
          tag.includes('badge:')
        )
        if (badgeTags.length) {
          const badgeTag = badgeTags[0]
          const node = document.createElement('div')
          node.className = `flex items-center font-secondary font-bold text-[12px] leading-[17px] text-white capitalize rounded-[5px] h-[23px] pl-[6px] badges-${handleize(
            badgeTag
          )}`
          node.innerHTML = `<p class="pl-[4px] pr-[7px]">${badgeTag.replace(
            'badge:',
            ''
          )}</p>`
          this.badge.appendChild(node)
          this.badge.classList.remove('hidden')
        } else {
          this.badge.classList.add('hidden')
        }
      } else {
        this.badge.classList.add('hidden')
      }
    }

    updateContent(key, className) {
      if (this.productData[key]) {
        this.querySelector(`.${className}`).textContent = this.productData[key]
      } else {
        this.querySelector(`.${className}`).textContent = ''
      }
    }

    updatePrice() {
      this.updatePriceItem(this.activeVariant)
    }

    updatePriceItem(object) {
      this.querySelector('.js-quick-price-original').textContent =
        window.formatter.format(object.price / 100)
      if (object.compare_at_price) {
        this.querySelector('.js-quick-price-compare').textContent =
          window.formatter.format(object.compare_at_price / 100)
        this.querySelector('.js-quick-price-compare').classList.remove('hidden')
      } else {
        this.querySelector('.js-quick-price-compare').classList.add('hidden')
      }
    }

    /**
     * Returns if the active variant is available or not. Only looks at inventory counts
     *
     * @returns {Boolean}
     */
    isAvailable() {
      const { available } = this.variantInventoryInfo(this.activeVariant);

      return available;
    }

    /**
     * Returns variant inventory info
     *
     * @param {Variant} variant
     * @returns {{available: Boolean,
                  inventory_quantity: Number,
                  inventory_policy: string,
                  ghost_quantity: Number}}
     */
    variantInventoryInfo(variant) {
      const variantInventoryOption = this.querySelector(
        `.js-variants-select option[data-id="${variant.id}"]`
      )

      let available = false
      let inventoryPolicy = 'deny'
      let inventoryQuantity = 0
      let ghostQuantity = 0

      if (variantInventoryOption) {
        inventoryPolicy = variantInventoryOption.dataset.inventoryPolicy
        inventoryQuantity = Number(variantInventoryOption.dataset.inventoryQuantity)
        ghostQuantity = Number(variantInventoryOption.dataset.inventoryGhostQuantity)
        available = inventoryQuantity > 0 || inventoryPolicy != 'deny'
      }

      return {
        available,
        inventory_quantity: inventoryQuantity,
        inventory_policy: inventoryPolicy,
        ghost_quantity: ghostQuantity
      }
    }

    setButtonStateAvailable(allInventoryFromGhosts) {
      const preOrderText = allInventoryFromGhosts ? 'This item ships within one week!' : ''
      this.updatePreorderText(preOrderText)

      this.atc.querySelector('p').innerHTML = this.buttonLabels['add']
      this.atc.querySelector('.js-icon-atc').classList.remove('hidden')
      this.atc.disabled = false
    }

    setButtonStateSoldOut() {
      this.querySelector('.js-variant-preorder').innerHTML = ''

      this.atc.querySelector('p').innerHTML = this.buttonLabels['sold_out']
      if (
        !this.atc.querySelector('.js-icon-atc').classList.contains('hidden')
      ) {
        this.atc.querySelector('.js-icon-atc').classList.add('hidden')
      }
      this.atc.disabled = true
    }

    setButtonStateBackinStock() {
      this.querySelector('.js-variant-preorder').innerHTML = ''
      this.atc.querySelector('p').innerHTML = this.buttonLabels['notify_me']
      this.atc.querySelector('.js-icon-atc').classList.remove('hidden')
      this.atc.disabled = false // need to enable button to allow notify me
    }

    updateButtons() {
      this.atc.disabled = true
      const {
        available,
        inventory_quantity: inventoryQuantity,
        ghost_quantity: ghostQuantity
      } = this.variantInventoryInfo(this.activeVariant);

      const allInventoryFromGhosts = inventoryQuantity === ghostQuantity;

      if (available) {
        this.setButtonStateAvailable(allInventoryFromGhosts)
      } else {
        if (this.backInStock) {
          this.setButtonStateBackinStock()
        } else {
          this.setButtonStateSoldOut()
        }
      }
    }

    updatePreorderText(text) {
      this.querySelector('.js-variant-preorder').innerHTML = ''
      const node = document.createElement('div')
      node.className =
        'w-full text-center py-10 font-primary text-desktop-heading-6 -tracking-[0.25px]'
      node.innerHTML = text
      this.querySelector('.js-variant-preorder').appendChild(node)
    }

    hasOption(name) {
      return this.productData.options.find((opt) => opt.toLowerCase() === name)
    }

    updateSwatches() {
      const optName = 'color'
      this.swatchesContainer = this.querySelector('.js-quick-swatches')
      this.swatchesListContainer = this.querySelector('.js-quick-swatches-list')
      this.swatchesListContainer.innerHTML = ''
      this.activeSwatchValue = this.querySelector('.js-active-swatch-value')

      if (this.hasOption(optName)) {
        this.swatchesContainer.classList.remove('hidden')
        this.swatchesContainer.classList.add(...['flex', 'lg:block'])

        const optionIndex =
          this.productData.options.indexOf(this.hasOption(optName)) + 1
        this.activeSwatchValue.textContent =
          this.activeVariant[`option${optionIndex}`]

        this.renderSwatches(optionIndex)

        this.swatchList = Array.from(
          this.swatchesListContainer.querySelectorAll('li')
        )
        this.activeSwatch = this.swatchList.find((swatch) =>
          swatch.classList.value.includes('active')
        )

        this.changeSwatchImages(this.activeVariant[`option${optionIndex}`])
        this.changeProductUrl()

        for (let i = 0; i < this.swatchList.length; i++) {
          this.swatchList[i].addEventListener(
            'mouseover',
            (e) => {
              this.previewSwatchName(
                this.swatchList[i].getAttribute('data-color')
              )
            },
            false
          )

          this.swatchList[i].addEventListener(
            'mouseout',
            (e) => {
              this.showActiveSwatchName()
            },
            false
          )

          this.swatchList[i].addEventListener(
            'click',
            (e) => {
              this.activeSwatch = this.swatchList[i]
              this.showActiveSwatchName()
              this.changeSwatch()
            },
            false
          )
        }
      } else {
        this.changeSwatchImages()
        this.swatchesContainer.classList.add('hidden')
        this.swatchesContainer.classList.remove(...['flex', 'lg:block'])
      }
    }

    renderSwatches(optionIndex) {
      const swatchValueList = this.productData.variants.reduce(
        (swatchValues, variant) => {
          if (swatchValues.indexOf(variant[`option${optionIndex}`]) === -1) {
            swatchValues.push(variant[`option${optionIndex}`])
          }
          return swatchValues
        },
        []
      )

      swatchValueList.forEach((swatchValue) => {
        this.renderSwatchItem(swatchValue, optionIndex)
      })
    }

    renderSwatchItem(swatchValue, optionIndex) {
      let moreClasses =
        this.activeVariant[`option${optionIndex}`] === swatchValue
          ? 'active'
          : ''
      const availableVariantWithSwatch = this.productData.variants.find(
        (variant) => variant[`option${optionIndex}`] === swatchValue && variant.available
      )
      if (!availableVariantWithSwatch) {
        moreClasses += ' unavailable'
      }

      const className = `relative flex w-[19px] h-[19px] lg:w-[25px] lg:h-[25px] rounded-full cursor-pointer hover:before:absolute hover:before:bg-black hover:before:w-full hover:before:h-full hover:before:top-0 hover:before:left-0 hover:before:rounded-full hover:after:absolute hover:after:bg-white hover:after:w-[17px] hover:after:h-[17px] lg:hover:after:w-[23px] lg:hover:after:h-[23px] hover:after:top-[1px] hover:after:left-[1px] hover:after:rounded-full ${moreClasses}`

      const itemContent =
        '' +
        ` <div class="absolute z-1 flex w-[13px] h-[13px] lg:w-[19px] lg:h-[19px] top-[3px] left-[3px] rounded-full color-swatches-${
          this.productData.handle
        }-${handleize(swatchValue)}">` +
        '   <span class="absolute w-full h-full top-0 left-0 rounded-full"></span>' +
        ' </div>'

      const node = document.createElement('li')
      node.className = className
      node.setAttribute('data-color', swatchValue)
      node.innerHTML = itemContent
      this.swatchesListContainer.appendChild(node)
    }

    previewSwatchName(swatchName) {
      this.activeSwatchValue.textContent = swatchName
    }

    showActiveSwatchName() {
      this.activeSwatchValue.textContent =
        this.activeSwatch.getAttribute('data-color')
    }

    changeSwatch() {
      this.swatchList.forEach((swatch) => {
        swatch.classList.remove('active')
      })
      this.activeSwatch.classList.add('active')

      this.changeSwatchImages(this.activeSwatch.getAttribute('data-color'))
      this.setActiveVariant()
      this.updateSizes()
      this.changeProductUrl()
    }

    getActiveVariantUrl() {
      return `/products/${this.productData.handle}?variant=${this.activeVariant.id}`
    }

    changeSwatchImages(swatch = '') {
      const IMAGE_ALT_DELIMITER = ' $|& ';
      this.imagesContainer = this.querySelector('.splide__list')
      this.imagesContainer.innerHTML = ''

      const images = this.productData.media
      let swatchImages = images
      if (swatch) {
        swatchImages = images.filter((image) => {
          return image?.alt && image.alt.split(IMAGE_ALT_DELIMITER)[0].toLowerCase() === swatch.toLowerCase()
        })

        if (!swatchImages.length) {
          swatchImages = images
        }
      }

      if (swatchImages.length) {
        swatchImages.forEach((img) => {
          this.renderImage(img, swatch)
        })
      }

      this.renderCarousel()

      if (
        swatchImages.length === 1 &&
        this.querySelector('.splide__pagination')
      ) {
        this.querySelector('.splide__pagination').classList.add('invisible')
      } else if (
        swatchImages.length > 1 &&
        this.querySelector('.splide__pagination')
      ) {
        this.querySelector('.splide__pagination').classList.remove('invisible')
      }
    }

    renderCarousel() {
      this.splideElement = this.querySelector('.splide')

      const option = {
        classes: {
          pagination: 'splide__pagination bottom-[1em] lg:bottom-[1.8em]',
          page: 'splide__pagination__page opacity-100 w-[7px] h-[7px] lg:w-[10px] lg:h-[10px] bg-grey-600 hover:bg-secondary-yellow hover:opacity-100 mx-[7px] lg:mx-[9px]',
        },
        type: 'loop'
      }
      const viewportWidth = window.innerWidth
      if (viewportWidth > 1023) {
        option['cover'] = true
      }

      const splide = new Splide(this.splideElement, option)

      splide.mount()
      splide.refresh()

      splide.on('resize', () => {
        splide.refresh()
      })
    }

    renderImage(img, swatch) {
      const node = document.createElement('li')
      node.className = 'splide__slide rounded-[5px] relative'
      node.innerHTML = `<a href="#" class="absolute cursor-pointer w-full h-full top-0 left-0 js-quick-image-link">&nbsp;</a><img src="${img.src}" alt="${swatch}" class="rounded-[5px]">`
      this.imagesContainer.appendChild(node)
    }

    setActiveVariant() {
      let optionIndex = -1
      let optName = 'color'

      /** @type {Variant[]} */
      let variants = deepClone(this.productData.variants)
      if (this.hasOption(optName)) {
        optionIndex = this.productData.options.indexOf(this.hasOption(optName)) + 1
        variants = variants.filter(
          (variant) =>
            variant[`option${optionIndex}`] === this.activeSwatch.getAttribute('data-color')
        )
      }

      optName = 'size'
      if (this.hasOption(optName)) {
        optionIndex = this.productData.options.indexOf(this.hasOption(optName)) + 1
        const activeVariant = this.findVariant(
          variants,
          this.activeSize,
          optionIndex,
          'size'
        )

        if (activeVariant) {
          this.activeVariant = activeVariant
        } else {
          const availableVariants = variants.filter((variant) => variant.available)
          if (availableVariants.length > 0) {
            this.activeVariant = availableVariants[0]
          } else {
            this.activeVariant =
              variants.find(
                (variant) =>
                  variant[`option${optionIndex}`] ===
                  this.activeSize.getAttribute('data-size')
              ) || variants[0]
          }
        }
      } else {
        this.activeVariant = variants[0]
      }
    }

    /**
     * Returns a variant that matches the option / optionIndex / type values
     *
     * @param {Variant[]} variants
     * @param {HTMLElement} option
     * @param {Number} optionIndex
     * @param {'size'|'any'} type
     * @returns {Variant}
     */
    findVariant(variants, option, optionIndex, type) {
      let available = true
      return variants.find((variant) => {
        available = this.isVariantSelectable(variant)

        if (type === 'any') return available

        if (this.backInStock) available = true

        return (
          variant[`option${optionIndex}`] === option.getAttribute('data-size') && available
        )
      })
    }

    /**
     * Returns if the variant can be selected or not.
     *  checks inventory policy but not if backInStock is enabled
     *
     * @returns {Boolean}
     */
    isVariantSelectable(variant) {
      const {
        available: inventoryAvailable,
        inventory_quantity: inventoryQuantity,
        inventory_policy: inventoryPolicy
      } = this.variantInventoryInfo(variant)

      let available = inventoryAvailable;
      if (inventoryPolicy !== 'deny') available = true

      return available
    }

    changeProductUrl() {
      const url = this.getActiveVariantUrl()
      const viewFullProduct = this.querySelector('.js-quick-product-url')
      const titleElement = this.querySelector('.js-quick-title')
      const imageLinkElements = this.querySelectorAll('.js-quick-image-link')

      viewFullProduct.setAttribute('href', url)
      titleElement.setAttribute('href', url)
      imageLinkElements.forEach((ele) => ele.setAttribute('href', url))

      this.updateButtons()
    }

    updateSizes() {
      const optName = 'size'
      this.sizesContainer = this.querySelector('.js-quick-sizes')
      this.sizesListContainer = this.querySelector('.js-quick-sizes-list')
      this.sizesListContainer.innerHTML = ''
      this.activeSizeValue = this.querySelector('.js-active-size-value')

      if (this.hasOption(optName)) {
        this.sizesContainer.classList.remove('hidden')
        this.sizesContainer.classList.add('block')

        const optionIndex =
          this.productData.options.indexOf(this.hasOption(optName)) + 1
        this.activeSizeValue.textContent =
          this.activeVariant[`option${optionIndex}`]

        this.renderSizes(optionIndex)

        this.sizeList = Array.from(
          this.sizesListContainer.querySelectorAll('button')
        )
        this.activeSize = this.sizeList.find((item) =>
          item.classList.value.includes('active')
        )

        this.changeProductUrl()

        for (let i = 0; i < this.sizeList.length; i++) {
          this.sizeList[i].addEventListener(
            'click',
            (e) => {
              this.activeSize = this.sizeList[i]
              this.showActiveSizeName()
              this.changeSize()
            },
            false
          )
        }
      } else {
        this.sizesContainer.classList.add('hidden')
        this.sizesContainer.classList.remove('block')
      }
    }

    showActiveSizeName() {
      this.activeSizeValue.textContent =
        this.activeSize.getAttribute('data-size')
    }

    renderSizes(optionIndex) {
      const sizeValueList = this.productData.variants.reduce(
        (sizeValues, variant) => {
          if (sizeValues.indexOf(variant[`option${optionIndex}`]) === -1) {
            sizeValues.push(variant[`option${optionIndex}`])
          }
          return sizeValues
        },
        []
      )

      sizeValueList.forEach((sizeValue) => {
        this.renderSizeItem(sizeValue, optionIndex)
      })
    }

    renderSizeItem(sizeValue, optionIndex) {
      /** @type {Variant[]} */
      let variants = deepClone(this.productData.variants)
      const optName = 'color'
      if (this.hasOption(optName)) {
        const swatchIndex = this.productData.options.indexOf(this.hasOption(optName)) + 1
        variants = variants.filter(
          (variant) =>
            variant[`option${swatchIndex}`] ===
            this.activeSwatch.getAttribute('data-color')
        )
      }

      const variantWithSize = variants.find(
        (variant) => variant[`option${optionIndex}`] === sizeValue
      )

      let moreClasses =
        this.activeVariant[`option${optionIndex}`] === sizeValue &&
        this.isVariantSelectable(this.activeVariant)
          ? 'bg-black text-white'
          : ''

      let available = false // default to not available
      if (variantWithSize) {
        moreClasses += ' active'
        available = this.isVariantSelectable(variantWithSize)
      }

      let disabled = false
      if (!variantWithSize || !available) {
        moreClasses += ' relative test-oos test-oos--quickshop'
        if (!this.backInStock) {
          disabled = true
        }
      }

      const className = 'flex items-center justify-center w-[39px] h-[39px] lg:w-[67px] lg:h-[57px]'
      const buttonClassName = `w-full h-full border border-grey-600/50 font-primary font-bold text-mobile-heading-6 lg:text-desktop-heading-6 bg-white text-black rounded-[2px] uppercase hover:bg-black hover:text-white disabled:text-grey-600 disabled:opacity-50 disabled:hover:bg-white disabled:hover:text-grey-600 ${moreClasses}`

      const node = document.createElement('li')
      node.className = className
      const button = document.createElement('button')
      button.className = buttonClassName
      button.textContent = truncateString(sizeValue, 5, '..')
      button.disabled = disabled
      button.setAttribute('data-size', sizeValue)
      node.appendChild(button)
      this.sizesListContainer.appendChild(node)
    }

    changeSize() {
      const classes = ['bg-black', 'text-white', 'active']
      this.sizeList.forEach((size) => {
        size.classList.remove(...classes)
      })
      this.activeSize.classList.add(...classes)

      this.setActiveVariant()
      this.changeProductUrl()
    }
  }

  if (customElements.get('quick-shop') === undefined) {
    customElements.define('quick-shop', QuickShop)
  }
}
